module.exports = __webpack_public_path__ + "static/img/advantageBg.aeaea6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/advantageBg.png
// module id = kC11
// module chunks = 2